
import Vue, { PropType } from "vue";
import { DateTime } from "luxon";
import { EarlytimeFlowDat } from "@/models/transaction/EarlytimeFlowDat";
import { VForm } from "vuetify/lib";
import { PetitionShiftSearch } from "@/models/petition/PetitionResponse";
import EarlyWorkForm from "@/components/form/EarlyWorkForm.vue";
import { Attendance } from "@/models/transaction/Attendance";

const message =
  "早出申請で選択した開始時間の30分前から、出勤の打刻ができます。";

interface VForm extends Vue {
  reset(): void;
  resetValidation(): void;
  validate(): boolean;
}

export default Vue.extend({
  name: "EarlyWorkApplication",
  components: { VForm, EarlyWorkForm },
  props: {
    date: {
      type: Object as PropType<DateTime>,
      required: true
    },
    shift: {
      type: Object as PropType<PetitionShiftSearch>,
      required: true
    },
    employeeId: {
      type: Number,
      required: true
    },
    affiliationId: {
      type: Number,
      required: true
    },
    attendance: {
      type: Object as PropType<Attendance>,
      required: true
    },
    adminView: {
      type: Boolean,
      required: true
    },
    appliedBy: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      form: new EarlytimeFlowDat({
        recordId: 0,
        employeeId: this.employeeId,
        affiliationId: this.affiliationId,
        shiftId: this.shift.shiftId,
        earlytimeWorkDate: this.date.toISO(),
        earlytimeWorkStart: "",
        earlytimeWorkBreak: "00:00",
        reason: "",
        isEarlytime: this.appliedBy
      }),
      message
    };
  },
  methods: {
    async onSubmit() {
      const form = this.$refs.form as VForm;
      if (!form.validate()) {
        this.$alert(
          "warning",
          "入力に誤りがあります。\n入力内容を確認してください。\n\n勤務時間変更を同日に申請されている場合は、\n休憩時間が合うように入力してください。"
        );
        return;
      }
      this.form.requestDate = DateTime.local().toISO();
      (this.form.startTimeStamp = this.attendance?.startTimeUnix
        ? DateTime.fromSeconds(this.attendance?.startTimeUnix).toFormat("HH:mm")
        : undefined),
        (this.form.endTimeStamp = this.attendance?.endTimeUnix
          ? DateTime.fromSeconds(this.attendance?.endTimeUnix).toFormat("HH:mm")
          : undefined);
      const result = await this.$post(
        this.Paths.petition.insert.earlyWork,
        this.form
      );
      if (result) {
        this.$alert("success", "申請に成功しました。");
        return true;
      } else {
        this.$alert("error", "申請に失敗しました。");
        return false;
      }
    }
  }
});
